import { EditProfileFormValues } from '../../../../../components/organisms/EditProfileForm/EditProfileForm';
import { UserFactory } from '../../../../../test-helpers/factories/UserFactory';
import { User } from '../../../../../types/backend/User';
import CreateAPIRoute from '../../../CreateRoute';
import client from '../../../portal-api/client';

type Params = { email: string };

type Response = Boolean;

const { APIRoute, MSW } = CreateAPIRoute<Params, Response>({
  client: client,
  path: 'auth/password-reset/start',
  method: 'post',
  mockData: (params) => {
    return true;
  },
  //   beforeRequest: (params) => {
  //     return params;
  //   },
  errorMessages: {
    'User does not exist':
      'This email does not exist. Please register an account.',
  },
});

const AuthPasswordReset = {
  APIRoute,
  MSW,
};

export default AuthPasswordReset;
